import { Link } from 'react-router-dom';
import { Card, CardContent } from './ui/card';
import { Badge } from './ui/badge';
import { Button } from './ui/button';
import { ShoppingCart, Package } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { useCart } from '../contexts/CartContext';
import { useCurrency } from '../contexts/CurrencyContext';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

export function ProductCard({ product }) {
  const { user } = useAuth();
  const { addToCart } = useCart();
  const { formatPrice } = useCurrency();
  const navigate = useNavigate();
  const primaryImage = product.images?.find(i => i.is_primary) || product.images?.[0];
  const imageUrl = primaryImage ? `${process.env.REACT_APP_BACKEND_URL}${primaryImage.url}` : null;

  const stockStatus = product.stock === 0 ? 'out' : 'in';
  const stockLabel = stockStatus === 'out' ? 'Agotado' : 'Disponible';
  const stockColor = stockStatus === 'out' ? 'destructive' : 'secondary';

  const handleAddToCart = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!user) { navigate('/login'); return; }
    try {
      await addToCart(product.id);
      toast.success('Producto agregado al carrito');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Error al agregar');
    }
  };

  return (
    <Link to={`/tienda/${product.id}`} data-testid={`product-card-${product.id}`}>
      <Card className="group overflow-hidden transition-shadow duration-150 hover:shadow-[0_10px_30px_rgba(0,0,0,0.06)] h-full flex flex-col">
        <div className="aspect-square bg-secondary/50 relative overflow-hidden">
          {imageUrl ? (
            <img src={imageUrl} alt={product.name} className="w-full h-full object-contain p-2" loading="lazy" />
          ) : (
            <div className="w-full h-full flex items-center justify-center">
              <Package className="h-16 w-16 text-muted-foreground/30" />
            </div>
          )}
          <div className="absolute top-2 right-2">
            <Badge variant={stockColor} className="text-xs">{stockLabel}</Badge>
          </div>
        </div>
        <CardContent className="p-4 flex-1 flex flex-col">
          <p className="font-mono text-xs text-muted-foreground mb-1">{product.sku}</p>
          <h3 className="font-display font-semibold text-sm leading-tight mb-1 group-hover:text-[hsl(var(--ring))] transition-colors duration-150 line-clamp-2">{product.name}</h3>
          {product.brand && <p className="text-xs text-muted-foreground mb-2">{product.brand}</p>}
          <div className="mt-auto flex items-center justify-between pt-3">
            <span className="font-display font-semibold text-lg">{formatPrice(product.price)}</span>
            {product.stock > 0 && (
              <Button size="sm" variant="outline" onClick={handleAddToCart} data-testid="product-add-to-cart-button" className="h-8 w-8 p-0">
                <ShoppingCart className="h-4 w-4" />
              </Button>
            )}
          </div>
        </CardContent>
      </Card>
    </Link>
  );
}
